import { defaultNumberRegex } from '@shared/evaluation-progress.utils';

/** Limpia el valor en blanco de una respuesta. */
export function normalizeBlankAnswer(answer: any): void {
  if (answer?.answer === '') answer.answer = null;
}

/** Limpia los valores en blanco de los subitems. */
export function normalizeBlankSubs(subs: any[]): void {
  for (const sub of (subs || [])) normalizeBlankAnswer(sub);
}

/** Resuelve el regex numérico cuando el tipo lo requiere. */
export function numberFallback(dataType: string, current: string | null): string | null {
  if (dataType === 'number' && !current) return defaultNumberRegex();
  return current;
}
